export default "/public/dist/img/notizia1607.jpeg";